import {BaseService} from './baseService.js';
import {SessionStorageUtil} from '../utils/browserStorageSanitizer.js';

/* 
 * Handles interaction with the company api
 */
export class CompanyService extends BaseService {
	
	constructor() {
		super();
		this.currentCompany = null;
	}
	
	async getCurrentCompany() {
		
		if (!this.currentCompany) {			
			this.currentCompany = await this.makeGETRequest("/api/resource/companies/current");			
		}		
		return new Promise((resolve, reject) => {
			resolve(this.currentCompany);
		});
	}
	
	clearWorkingCompany() {
		SessionStorageUtil.removeItem('workingCompany');
	}
	
	async getWorkingCompanyId() {
		var workingCompanyId = SessionStorageUtil.getItem('workingCompany');
		if (workingCompanyId) {
			return new Promise((resolve, reject) => {
				resolve(this.workingCompanyId);
			});
		} else {
			await this.getCurrentCompany().then(function(companyFull) {
				return new Promise((resolve, reject) => {
					resolve(companyFull.company.companyId);
				});
			});
		}
	}
	
	async switchCompanies(newCompanyId, primary) {	
		var oldCompanyId = null;
		await this.getCurrentCompany().then(function(companyFull) {
			oldCompanyId = companyFull.company.companyId;
		});
		
		// Clear any temporary company override before a normal switch.
		await this.clearTemporaryCompanySwitch();
		
		await this.applyWorkingCompany(newCompanyId, primary, oldCompanyId);
	}

	/**
	 * Sets the working company in sessionStorage and records the switch tracking event.
	 * Does not clear a temporary session override (use switchCompanies for that).
	 */
	async applyWorkingCompany(newCompanyId, primary, oldCompanyId) {
		if (!oldCompanyId) {
			await this.getCurrentCompany().then(function(companyFull) {
				oldCompanyId = companyFull.company.companyId;
			});
		}

		var companySwitchRequest = {
			currentCompanyId: oldCompanyId,
			requestedCompanyId: newCompanyId
		};
		this.currentCompany = null;
		
		if (primary) {
			SessionStorageUtil.removeItem('workingCompany');
		} else {
			SessionStorageUtil.setItem('workingCompany', newCompanyId);
		}
		await this.makePOSTRequest('/api/resource/user-trackings/switch-company-event', companySwitchRequest);
		window.dispatchEvent(new CustomEvent('companyswitch', {
			detail: {
				companyId: newCompanyId,
				primary: primary,
				oldCompanyId: oldCompanyId
			}
		}));
	}

	async temporarySwitchCompany(companyId) {
		var result = await this.makePOSTRequest('/api/resource/companies/' + companyId + '/temporary-switch', {});
		if (result && result.success === false) {
			return Promise.reject(result);
		}
		return result;
	}

	async clearTemporaryCompanySwitch() {
		try {
			const res = await this.performFetch('/api/resource/companies/temporary-switch', {
				method: 'DELETE'
			});
			if (res.ok) {
				return { success: true };
			}
			console.log('Warning: clear temporary company switch returned status ' + res.status);
			return { success: false };
		} catch (error) {
			console.log('Warning: Failed to clear temporary company switch.', error);
			return { success: false };
		}
	}
	
	async saveCompany(companyId, companyData) {
		var companySaved = await this.makePUTRequest('/api/resource/companies/' + companyId, companyData);
		this.currentCompany = null;
		return companySaved;
	}
	
	async loadCompanies(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var companies = await this.makeGETRequest("/api/resource/companies" + params);
		return companies;
	}
	
	async inactivateCompany(companyId) {
		var newCompany = await this.makePUTRequest("/api/resource/companies/" + companyId + "/inactivate");
		return newCompany;
	}
	
	async activateCompany(companyId) {
		var newCompany = await this.makePUTRequest("/api/resource/companies/" + companyId+ "/activate");
		return newCompany;		
	}
	
	async updateCompanyType(companyId, typeModel) {
		var newCompany = await this.makePUTRequest("/api/resource/companies/" + companyId + "/company-type", typeModel);
		return newCompany;		
	}	
	
	async getCompany(companyId) {
		var company = await this.makeGETRequest("/api/resource/companies/" + companyId);
		return company;
	}

	async getCompaniesLookup(status) {
		var params = '';
		if (status) {
			params = '?status=' + status;
		}
		var companies = await this.makeGETRequest("/api/resource/companies/lookup" + params);
		return companies;		
	}

	async getPermissionsForCompany(companyId) {	
		var data = await this.makeGETRequest('/api/resource/companies/' + companyId + '/permissions');		
		return data;
	}	

};

